import { useState, useCallback } from 'react';
import { remisionesService } from '../api/remisionesService';
import { RemisionesResponse } from 'types/remisiones';
import toast from 'react-hot-toast';

export const useRemisiones = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<RemisionesResponse | null>(null);

  const searchRemisiones = useCallback(async (sku: string, page = 1, limit = 30) => {
    if (!sku.trim()) {
      toast.error('Por favor ingrese un SKU válido');
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const response = await remisionesService.getRemisionesBySKU(sku, page, limit);
      setData(response);
      
      if (response.data.length === 0) {
        toast(`No se encontraron remisiones para el SKU: ${sku}`, {
          icon: 'ℹ️'
        });
      } else {
        toast.success(`Se encontraron ${response.totalRemisiones} remisiones para ${sku}`);
      }
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Error desconocido';
      setError(errorMessage);
      toast.error(`Error al buscar remisiones: ${errorMessage}`);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const clearData = useCallback(() => {
    setData(null);
    setError(null);
  }, []);

  return {
    isLoading,
    error,
    data,
    searchRemisiones,
    clearData
  };
};
